import { render, staticRenderFns } from "./m-editSoal.vue?vue&type=template&id=07b2ded4&"
import script from "./m-editSoal.vue?vue&type=script&lang=js&"
export * from "./m-editSoal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports